import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EnergySavingsLeafOutlinedIcon from '@mui/icons-material/EnergySavingsLeafOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
import SpeedOutlinedIcon from '@mui/icons-material/SpeedOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import type { SvgIconComponent } from '@mui/icons-material';
import type { ChartId } from './chartCatalog';

/** The icon next to each chart's title (PT-6804); every chart of the catalog has one. */
export const CHART_ICONS: Readonly<Record<ChartId, SvgIconComponent>> = {
  originator: GroupsOutlinedIcon,
  rootCause: DescriptionOutlinedIcon,
  impact: SpeedOutlinedIcon,
  environmentalAspect: EnergySavingsLeafOutlinedIcon,
  workType: BuildOutlinedIcon,
  hsEffect: HealthAndSafetyOutlinedIcon,
  hazardType: WarningAmberOutlinedIcon,
  completedInspectionsByTemplate: FactCheckOutlinedIcon,
  inspectionEvolution: ShowChartOutlinedIcon,
  inspectionTriplet: AssessmentOutlinedIcon,
  detectedResolved: CompareArrowsOutlinedIcon,
  resolutionTime: AccessTimeOutlinedIcon,
};
